import { render, staticRenderFns } from "./FlowNodeAttributes.vue?vue&type=template&id=7b86cd94&scoped=true&"
import script from "./FlowNodeAttributes.vue?vue&type=script&lang=js&"
export * from "./FlowNodeAttributes.vue?vue&type=script&lang=js&"
import style0 from "./FlowNodeAttributes.vue?vue&type=style&index=0&id=7b86cd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b86cd94",
  null
  
)

export default component.exports